import Price from 'types/Price';

export const defaultPrice: Price = { amount: 0, currency: 'PLN' };
